import React, { useEffect, useRef, useState } from "react";
import { fetchFeedData } from "./MemberProfileFeedData.js";
import "../../Styles/MemberProfileFetchData.css";
import CommentsSection from "../../../../common/Comment/CommentsSection";
import ShareButton from "../../../../common/Actions/shareButton"
import LikeButton from "../../../../common/Actions/likeButton"
import SuggestButton from "../../../../common/Actions/suggestButton"

const MPFeedContent = ({userId}) => {
  const [feedData, setFeedData] = useState([]);
  const [newComment, setNewComment] = useState("");
  const commentBoxRef = useRef(null);

  const handleAddComment = (postId) => {
    if (newComment.trim()) {
    onAddComment(postId, newComment.trim()); // Call onAddComment with postId
    setNewComment(""); // Reset input field
    }
  };

  const onAddComment = async (postId, newComment) => {
    console.log("Adding comment to post:", postId, newComment);
  
    const addedComment = {
     userId: "currentUser", // Replace with the actual user
      comment: newComment,
      timestamp: Date.now(),
    };
  
    setFeedData((prevFeedData) =>
      prevFeedData.map((user) => ({
        ...user,
        posts: user.posts.map((post) =>
          post.postId === postId
            ? { ...post, comments: [...post.comments, addedComment] } // Update only the specific post
            : post
        ),
      }))
    );
  
    // Delay scrolling slightly to allow UI update
    setTimeout(() => {
    if (commentBoxRef.current) {
      commentBoxRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
    }, 100);
    // return addedComment;
  };
  

  useEffect(() => {
    const loadFeedData = async () => {
      const data = await fetchFeedData();
      setFeedData(data);
    };
    loadFeedData();
  }, []);

  // Fix: Close the function properly
  const addComment = (mediaIndex, newComment) => {
    setNewComment((prev) => {
      const updatedComments = {
        ...prev,
        [mediaIndex]: [...(prev[mediaIndex] || []), newComment],
      };
      localStorage.setItem("comments", JSON.stringify(updatedComments)); // Update localStorage immediately
      return updatedComments;
    });
  };

  return (
    <div className="mp-feed-container" >
      {feedData.length === 0 ? (
        <p>Loading...</p>
      ) : (
        feedData.map((user) => (
          <div key={userId} className="mp-user-feed">
            <div classname="mp-user-action-container">
              <div className="mp-user-container">
                <p className= "mp-text-label" style={{marginLeft: 10, marginTop: 10}}> @{user.userId}</p>
              </div>
            </div>

            {user.posts.map((post) => (
              <div key={post.postId} className="mp-post-card">
                {/* <div className="mp-feed-header">
                    <p className= "mp-text-label" style={{marginLeft: 10}} >
                      {post.location}, {new Date(post.timestamp).toLocaleString()}
                    </p>
                  </div> */}

                {/* Post Media */}
                <div className="mp-feed-media">
                  <p className= "mp-text-label" style={{marginLeft: 10}} >{post.descriptions}</p>
                  {Array.isArray(post.medias) && post.medias.length > 0 &&
                    post.medias.map((media, index) => (
                      <div key={index}>
                        {media.mediatype === "image" ? (
                          <img src={media.mediaurl} alt="Post Media" className="mp-media-img" style={{ width: "%100" }} />
                        ) : media.mediatype === "video" ? (
                          <video controls className="mp-media-video">
                            <source src={media.mediaurl} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        ) : null}
                      </div>
                    ))
                  }
                </div>

                {/* Row 3: Likes, Shares, Suggestions, Impressions */}
                <div style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
                  <div className="mp-post-stats-left" style={{display: "flex", flexDirection: "row", gap:50 }}>
                    <LikeButton />  <ShareButton/> <SuggestButton />
                  </div>
                  <div className="mp-post-stats-right">
                    <span className="mp-text-label"> 👀 {post.impressions=100} Impressions    </span>
                  </div>
                </div>

                {/* Comments Section */}
                <div className="mp-feed-comments" style={{background: "none"}}>
                  <h4 className="mp-text-label">Comments:</h4>
                  <div class="mp-comments">
                    {Array.isArray(post.comments) && post.comments.length > 0 ? (
                      post.comments.map((comment, index) => (
                        <div
                        key={index}
                        className="mp-comment"
                        style={{ marginLeft: 10, marginBottom: 10 }}
                        ref={index === post.comments.length - 1 ? commentBoxRef : null} // Attach ref to last comment
                      >
                        <strong>{comment.userId}:</strong> {comment.comment}
                        <span className="mp-comment-time"> ({new Date(comment.timestamp).toLocaleString()})</span>
                      </div>
                    ))
                  ) : (
                    <p>No comments yet.</p>
                  )}
                  </div>
                  <div className="mp-add-comment">
                    <input
                      type="text"
                      value={newComment}
                      placeholder="Add a comment..."
                      onChange={(e) => setNewComment(e.target.value)}
                      className="mp-comment-input"
                    />
                      <button onClick={() => handleAddComment(post.postId)} className="mp-add-comment-button">
                        Add
                      </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))
      )}
    </div>
  );
};

export default MPFeedContent;
